import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<mat-tab-group  mat-stretch-tabs >
    <h1>காயத்ரி ஜபம்</h1>
    <mat-tab label="தமிழ்">
    <mat-accordion>
      <mat-expansion-panel>
      <mat-expansion-panel-header>01-தேவையானவை
      </mat-expansion-panel-header>
      <div class="div3">
       
          திருமண்பெட்டி அல்லது விபூதிப்பெட்டி<br>
  
          தாம்பாளம்<br>
  
          ஆசமனத்துக்கு ஒரு டம்ளர் ஜலம்<br>
  
          காயத்ரி ஜப மந்திரக் குறிப்பு<br>
  
          பவித்திரம் இடுக்குப்பில்<br>
  
          மணைப்பலகை<br>
  
          எண்ணுவதற்கு மணிகள் அல்லது பாக்கு அல்லது கொட்டைகள்
        
      </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>02-காயத்ரீ மகிமை
        </mat-expansion-panel-header>
        <div class="div3">
          ப்ரணவ வியாஹ்ருதிகளோடு காயத்ரீயை இரு ஸந்தியைகளிலும் ஜபிப்பவன் வேத பாராயண புண்ய பலனை அடைகிறான்.
            - மனு
            பிரம்மசர்ய விரதத்துடனும் மிதா ஹாரியாயும் பூததயையுடனும் லக்ஷ காயத்ரி ஜபம் செய்பவன் ஸகல பாவங்களினின்றும் விடுபடுகிறான்.
            - ஸம்வர்த்தர்
            மூவேந்தர்களையும் அனுஷ்டிக்க வேண்டிய ஸகல கர்மங்களையும் விட்ட போதிலும் காயத்ரீயை மட்டும் ஜபித்து வருபவன் பாப பயம் அற்றவனாகிறான்.
            - விஸ்வாமித்திரர்
            எவ்வப்பொழுது தான் பாவஞ் செய்துவிட்டதாக கருதுகிறானோ அப்பொழுதெல்லாம் நெய் கலந்த திலங்களால் அக்னியில் காயத்ரீயைச் சொல்லி ஹோமமோ, காயத்ரீ ஜபமோ செய்யச் சுத்தமாகிறான்.
            - வஸிஷ்டர்
            காயத்ரி ஜபம் செய்தால்தான் மற்ற அனைத்து வைதீக கர்மங்களையும் செய்வதற்கு யோக்யதை உண்டாகும். ஸந்த்யாவந்தனம் காயத்ரி ஜபம் செய்யாதவர்கள் செய்யும் எந்த வைதீகக் கர்மா, பூஜை, வழிபாடு எதுவும் நல்ல பலனைத் தராது என்று சாஸ்த்ரம்.
            காயத்ரியை மாதாவை வழிபடுவதுபோல் வழிபடவேண்டும். கடவுள் தன் பக்தர்களுக்கு பல விததங்களில் அருள்பாலிக்கிறார். மற்ற யாரைக்காட்டிலும் நம் தாய்தான் நம்மை அதிகமாக அன்புகாட்டி தேவைகளை பார்த்துப் பார்த்து பூர்த்தி செய்வாள். அதுபோல் காயத்ரி மாதா ஆனவள் தன்னைத் துதிக்கும் பக்தனுக்கு பல மடங்கு பலன்களை அள்ளிக்கொடுப்பவள் ஆகும். காயத்ரி ஜபம் செய்யாதவன் பண்ணும் புண்ணிய காரியங்களுக்கு பலன் ஒருபங்கு என்றால், காயத்ரி ஜபம் பண்ணபவனுக்கு 100 பங்கு பலன் கிட்டும் என்று சொல்லப்பட்டுள்ளது. காயத்ரி ஜபத்தை விடாமல் அநுஷ்டிப்பவன் வாழ்க்கையில் எல்லாவித மேன்மைகளையும் மிகச் சுலபமாக அடைவான்.
           
        </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>03-ஜபவிதி
          </mat-expansion-panel-header>
          <div class="div3">
           வாசிகம், உபாம்சு, மானஸமென ஜபம் மூவகையாகும். இவை முறையே ஒன்றுக்கொன்று சிறந்ததாகும்.
              நடந்து கொண்டும், சிரித்துக் கொண்டும், பக்கங்களைப் பார்த்து கொண்டும், ஊன்றி, சார்ந்து கொண்டும், வம்புகள் பேசி (கேட்டு) க் கொண்டும், தலையை மூடிக் கொண்டும், கால்களை மாறிமாறிப் பூமியில் ஊன்றிக் கொண்டும், கைகளால் பூமியைத் தொட்டுக் கொண்டும், ஏகாத்ர சித்தமின்றியும், உரத்தும் ஜபிக்கக் கூடாது.
              பவித்ரமின்றியும், தீட்டோடும், உரத்தும், கைகளை மூடிக் கொள்ளாமலும், தலையை மூடிக் கொண்டும் ஜபம் செய்யக் கூடாது.
           
          </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>04-தயாராகுதல்
            </mat-expansion-panel-header>
            <div class="div3">
              நாம் உலகில், எங்கிருந்தாலும் ப்ரஹ்ம முஹூர்த்தம் எனப்படும்
              காலை 4.30 மணி அளவில் எழுந்துவிடுவது உடல் மட்டுமல்ல
              மனதையும் மிகவும் ஆரோக்யமாக வைத்துக்கொள்ள உதவும். <br>
              பொதுவாக வைதீக காரியம் இருந்தாலும் இல்லாவிட்டாலும்,
              காலைக் கடன்களை முடித்தவுடன், சாதாரணமாக ஒரு சிறு குளியல்
              செய்வது படுக்கையில் நாம் அறியாமல் ஏற்படுத்திக்கொண்ட,
              அசுத்தம், கழிவு இவற்றை நீக்கி சுத்தம் பெற உதவும்.<br>
      
              1008 காயத்ரி ஜபம் பண்ண சுமார் 100 நிமிடங்கள் ஆகும்,
              இடையில், இயற்கை உபாதை, மற்ற இடையூறுகள் நேராதவாறு தயார்
              செய்துகொள்ளவும்.<br>
      
              வழக்கம்போல், கச்சம் உடுத்தி, திருமண் காப்பு, சந்தியாவந்தனங்களை
              முடித்துக்கொண்டு, பெருமாள் ஸேவித்து, பெரியவாளிடம் அனுமதி பெற்று
              ஸங்கல்ப குறிப்பு, எண்ணுவதற்கு ஏதேனும் சாதனம் இருந்தால் எடுத்து வைத்துக்கொண்டு
              ஜபம் பண்ண ஆரம்பிக்கவும்.
            </div>
            </mat-expansion-panel>
    </mat-accordion>
    
  <h1>காயத்ரி ஜபம் யஜூர் மற்றும் அனைவருக்கும்</h1>
  <p class="svk">ஆசமனம்</p>
  <div class="hint">ஆசமனம், ப்ராணாயாமம் அடிக்கடி
    செய்யவேண்டியிருக்கும், எனவே, இதை நன்றாகத்
    தெரிந்து வைத்துக்கொண்டு கர்மாவைச் செய்தால்
    விரைவாகவும், சிறப்பாகவும் செய்யலாம்.
    </div>

    <hr>
  <div>
    <img src="assets/img/achamanam.gif">
  </div>
  <div class="svk2">Achamanam - Audio </div>
      <audio controls>
      <source src="http://www.brahminsnet.com/upakarma/audio/achamanam.ogg" type="audio/ogg">
        <source src="http://www.brahminsnet.com/upakarma/audio/mp4/achamanam.mp4" type="audio/mp4">
    Your browser does not support the audio element.
    </audio>

  <div class="hint">ஒரு நாளில், ஒரு கர்மாவின்
    ஆரம்பத்திலும், முடிவிலும் இரண்டு முறை
    ஆசமனம் செய்யவேண்டும். இடையிடையே
    ஒவ்வொரு முறை செய்தால் போறும்.
    </div>
    <hr>
  <div class="sans">
    ओं अच्युताय नम:। ओं अनन्ताय नम:। <br>
    ओं गोविन्दााय नम:।<br>
    <ion-grid>
      <ion-row>
        <ion-col class="sans">ओं केशवाय नम:। </ion-col>
        <ion-col class="sans">नारायणाय नम:।</ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans">माधवाय नम:।</ion-col>
        <ion-col class="sans">गोविन्दाय नम:।</ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans">विष्णवे नम:। </ion-col>
        <ion-col class="sans">मधुसूदनाय नम:।
         </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans"> त्रिविक्रमाय नम:। </ion-col>
        <ion-col class="sans">वामनाय नम:।
          </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans">श्रीधराय नम:। </ion-col>
        <ion-col class="sans">हृषीकेशाय नम:।
          </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans">पद्मनाभाय नम:। </ion-col>
        <ion-col class="sans">दामोदराय नम:।</ion-col>
      </ion-row>
    </ion-grid>
     </div>
  <hr>
  <div>
      <img src="assets/img/Praanaayaamam1.jpg" class="img2">

      <div class="hint">மணையில் இரு தர்பங்களை ஆசனமாகப்
        போட்டுக்கொண்டு, அதன்மேல் கிழக்கு நோக்கி அமரவும்.
        </div>
    </div>
    <hr>
    <div>
      <img src="assets/img/Praanaayaamam2.jpg" class="img2">

      <div class="hint">இரு தர்பங்களாலான பவித்திரத்தை,
        வலது மோதிர விரலில் அணிந்து, அதனுடன் இரு
        தர்பங்களைச் சேர்த்து இடுக்கிக்கொள்ளவும்.
        </div>
    </div>
    <p class="clear"></p><hr>


    <div>
      <img src="assets/img/Praanaayaamam3.jpg" class="img2">

      <div class="hint">வலது மூக்குத் துவாரத்தை, வலது
        கட்டை விரலால் அழுத்தி அடைக்கவும்.
      </div>
    </div>

    <p class="clear"></p><hr>
    <div>
      <img src="assets/img/Praanaayaamam4.jpg" class="img2">
      <div class="hint"> வாயை நன்கு மூடி,
        சுட்டு விரல், நடு விரல்களை உள்ளே மடித்து,
        இட மூக்குத் துவாரம் வழியாக, வெளிக்காற்றை,
        முடிந்தவரை உள்ளிழுத்து நிறுத்தி,
        மோதிர, சுண்டு விரல்களால், இடமூக்குத் துவாரத்தையும்
        நன்கு அடைத்து ப்ராணாயாம மந்திரத்தை 3 முறை சொல்லவும்.
        </div>
    </div>
    <p class="clear"></p><hr>

    <div class="prayogam">
      ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ: ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம்,
      தத்ஸவிதுர்வரேண்யம் பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத் ஓமாப: ஜ்யோதீரஸ:
     அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.
    </div>
    <div class="sans"></div>
  <hr>
  <div class="head2">ப்ராணாயாமம்</div>
  <hr>
  <div class="sans">
    ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
    ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
  </div>
 <hr>

  <div>
    <img src="assets/img/praanaayaamam.gif">
  </div>


  <div class="item">வடகலை ஆரம்பம்</div>
<hr>
  <div>
    <img src="assets/img/kaikoopu.jpg" class="img2">
    <div class="hint">கையைக் கூப்பிக்கொண்டு
      மந்திரங்களைச் சொல்ல ஆரம்பிக்கவும்.
    </div>
  </div>
<hr>

  <div class="prayogam">ஓம் அஸ்மத் குருப்யோ நம: ஸ்ரீமான் வேங்கட நாதார்ய:
     கவிதார்கிக கேசரி வேதாந்தாசார்ய வர்யோமே ஸந்நிதத்தாம்
     ஸதாஹ்ருதி குருப்ய: தத்குருப்யஸ்ச்ச நமோவாகம் அதீமஹே
     வ்ருணீமஹேச தத்ராத்யௌ தம்பதி ஜகதாம்பதி ஸ்வசேஷ
     பூதேநமயா ஸ்வீயை: ஸர்வபரிச்சதை:
    விதாதும் ப்ரீதமாத்மாநம் தேவ: ப்ரக்ரமதே ஸ்வயம்.</div>
    <hr>
  <div class="sans">
    ओं अस्मत्गुरुभ्या नम:। श्रीमान् वेङ्कटनाथार्य: कवितार्किककेसरी। वेवान्ताचार्यवर्यो मे सिन्नधत्तां सदाहृदि|| गुरुभ्य: तद्गुरुभ्यश्च
    नमोवाकं अधीमहे। वृणीमहे च तत्राद्यौ दम्पती जगतां पती ।। स्वशेष भूतेन मया स्वीयै: सर्वपरिच्छदै: । विधातुं प्रीतमात्मानं
    देव: प्रक्रमते स्वयम् ।।

  </div>
  <hr>
  <div class="item">தென்கலை, ஸ்மார்த்தா ஆரம்பம் வடகலை தொடர்ச்சி</div>

  <div class="prayogam">
      சுக்லாம்பரதரம் விஷ்ணும் சசிவர்ணம் சதுர்புஜம் ப்ரஸன்னவதனம்
      த்யாயேது ஸர்வவிக்னோபசாந்தயே யஸ்யத்விரத வக்த்ராத்யா:
      பாரிஷத்யா:       பரஸ்சதம் விக்னம் நிக்னந்தி சததம்
      விஷ்வக்ஸேனம் தமாச்ரயே.
  </div>
  <hr>
  <div class="sans">
    शुक्लाम्बरधरं विष्णुं शशिवर्णं चतुर्भुजम् । प्रसन्नवदनं ध्यायेत् सर्वविघ्नोपशान्तये ।। यस्यद्विरदवक्त्राद्या: पारिषद्या:
    पर:शतम् । विघ्नं निघ्नन्ति सततं विष्वसेनं तमाश्रये ।।

  </div>
<hr>
  <div>
    <img src="assets/img/Sankalpam.jpg" class="img2">
    <div class="hint">வலது தொடையில் இடதுகைமேல்
      வலது கைவைத்து</div>
  </div>

  <p class="clear"></p><hr>
  <div class="prayogam"> ஹரிரோம்தத்<br />
    ஸ்ரீ கோவிந்தா கோவிந்த கோவிந்தா அஸ்யஸ்ரீ பகவத: மஹாபுருஷ்ஸ்ய
     விஷ்ணோராஜ்ஞயா ப்ரவர்த்தமானஸ்ய ஆத்ய ப்ரஹ்மண:
     த்விதீயபரார்த்தே
    ஸ்ரீ ஸ்வேதவராஹ கல்பே வைவஸ்வத மன்வந்தரே
    கலியுகே ப்ரதமே பாதே
  </div>

  <div class="svk">இந்தியாவில் இருப்பவர்கள்</div>
  <div class="prayogam"> ஜம்பூத்வீபே பாரதவர்ஷே பரதக்கண்டே

  </div>

  <div class="svk">
      வெளிநாட்டில் இருப்பவர்கள் :
      த்வீபம் வர்ஷம் கண்டம் தெரியாதவர்கள் “விஷ்ணு” என்பதை
      உபயோகித்துக்கொள்ளலாம். அதாவது “விஷ்ணு த்வீபே”
      “விஷ்ணு வர்ஷே”, “விஷ்ணு கண்டே” என்று சொல்லலாம்

  </div>
<hr>
  <div class="svk">எல்லோரும் சொல்லவும்</div>
  <div class="prayogam">சகாப்தே மேரோ: தக்ஷிணே பார்சவே அஸ்மின்
    வர்தமானானாம் வ்யவஹாரிகானாம் ப்ரபவாதீநாம் ஷஷ்டி
    ஸம்வத்ஸராணாம் மத்யே
    .....</div>
    <hr>
  <div class="sans">
    हरि: ओं तत् (सत्) श्रीगोविन्द गोविन्द गोविन्द। अस्य श्रीभगवत: महापुरुषस्य श्रीविष्णो: आज्ञया प्रवर्तमानस्य अद्यब्रह्मण: द्वितीयपराार्धे
    श्रीश्वेतवराहकल्पे वैवस्त्वत मन्वन्तरे कळियुगे प्रथमेपादे जम्बूद्वीपे भारतवर्षे भरतखण्डे शकाब्दे मेरो: दक्षिणेपार्श्वे
    अस्मिन् वर्तमानानां व्यवहारिकाणां प्रभवादीनां षष्टिसंवत्सराणां मध्ये
  </div>
<hr>
  <div class="head2">
    12-08-2022 க்கான ஸங்கல்பம்:
  </div>
  <div class="svk2">12-08-2022-Sankalpam - Audio </div>
  <audio controls>
    <source src="http://www.brahminsnet.com/upakarma/audio/12-08-2022.ogg" type="audio/ogg">
      <source src="http://www.brahminsnet.com/upakarma/audio/mp4/12-08-2022.mp4" type="audio/mp4">
  Your browser does not support the audio element.
  </audio>
  <hr>
  <div class="prayogam">சுபக்ருது நாம ஸம்வத்ஸரே - தக்ஷிணாயனே - க்ரீஷ்ம ருதௌ -
    கடக மாஸே - சுக்ல பக்ஷே -பௌர்ணமாஸ்யாம் (08.00 am)/ ப்ரதமாயாம்  சுப திதௌ -
    வாஸர: ப்ருகு வாஸர யுக்தாயாம்
    - ச்ரவிஷ்டா நக்ஷத்ர யுக்தாயாம் -
    சௌபாக்ய யோக யுக்தாயாம் - பவ(08.00am)/பாலவ கரண யுக்தாயாம் - ஏவங்குண, விசேஷண விசிஷ்டாயாம் - அஸ்யாம்
    பௌர்ணமாஸ்யாம் (08.00 am)/ ப்ரதமாயாம் சுப திதௌ
  </div>
  <hr>
  <div class="sans">
    .... शुभकृतु नाम संवत्सरे दक्षिणयने - ग्रीष्म ऋतौ
    कटक मासे शुक्ल पक्षे पौर्णमास्याम् (08.00 am)/  कूष्ण पक्षे प्रथमायां शुभ तिथौ वासर: भृगु वासर युक्तायां
    श्रविष्टा  नक्षत्र युक्तायां  सौभाग्य योग युक्तायां भव (08.00am)/
    बालव करण युक्तायां एवङ्गुण विशेषण विशिष्टायां अस्यां पौर्णमास्याम् (08.00 am)/ प्रथमायां शुभ तिथौ
    श्रीभगवदाज्ञया श्रीमन्नारायण प्रीत्यर्थं
  </div>
  <div class="item">காயத்ரி ஜப ஸங்கல்பம் :</div>

  <div class="svk">
    வடகலை :
  </div>
  <div class="prayogam"> ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம்</div>

  <div class="svk">
    தென்கலை :
  </div>
  <div class="prayogam"> ஸ்ரீ பகவதாஜ்ஞயா ஸ்ரீபகவத் கைங்கர்ய ரூபம்
     </div>

  <div class="svk">
    ஸ்மார்த்தா :
  </div>
  <div class="prayogam"> மமோ பார்த்த சமஸ்த துரிதக்ஷய த்வாரா
    ஸ்ரீ பரமேஸ்வர ப்ரீத்யர்த்தம்

  </div>
  <hr>
  <p class="svk">Use the above convention in all the places -<br>
    இந்த ஸம்ப்ரதாயத்தை அனைத்து இடத்திலும் கடைபிடிக்கவும். </p>
    <hr>

  <div class="svk">எல்லோரும் சொல்லவும்:</div>
  <div class="prayogam">
      மித்யாதீத ப்ராயச்சித்தார்த்தம் ஸம்வத்ஸர ப்ராயச்சித்தார்த்தம்
      (1008 பண்ணுகிறவர்கள் :)அஷ்டோத்ர ஸஹஸ்ர சங்க்யயா /<br>
      (108 பண்ணுகிறவர்கள் :)அஷ்டோத்ர சத சங்க்யயா
      காயத்ரீ மஹா மந்த்ர ஜபம் கரிஷ்யே.
  </div>
  <hr>
  <div class="sans"> मिथ्याधीत प्रायश्रित्तार्थं संवत्सर प्रायश्रित्तार्थं अष्टोत्तर(सहस्र) संख्यया गायत्री महामन्त्रजपं करिष्ये।</div>
  <hr>
  <div class="hint"> இது ஸங்கல்பம் ஆகும். இடுக்கு தர்பங்களை வடக்கே (இடதுபுறம்) எரியவும்.
      <hr>ஸாமவேதிகள் மட்டும் "ததங்கம் யஜ்ஞோபவீத தாரணம் கரிஷ்யே" என்று சேர்த்து சங்கல்பம்
      பண்ணிக்கொண்டு
      உபாகர்மாவில் கண்டுள்ளபடி பூணலும் போட்டுக் கொள்ளவும்.
  </div>
  <div class="svk">வடகலையார் மட்டும் : கை கூப்பிக்கொண்டு</div>
  <div class="prayogam">பகவாநேவ ஸ்வசேஷ பூதமிதம் காயாத்ரீ ஜபாக்யம் கர்ம ஸ்வஸ்மை
    ஸ்வப்ரீதயே பகவாந் ஸ்வயமேவ காரயதி
    என்று “ஸாத்வீக த்யாகம்” பண்ணிக் கொள்ளவும். </div>

  <div class="svk">எல்லோரும் சொல்லவும்:</div>
  <div class="hint"> எழுந்து, ஜபம் செய்யும் இடத்தில் சிறிது தீர்த்தம் ப்ரோக்ஷிக்கவும்</div>
  <hr>
  <div class="prayogam">
    “ஓம் பூர்புவஸ்ஸுவ:”</div>
    <br>
  <div class="sans">ओं भूर्भुवस्सुव:</div>
<hr>
  <div class="svk"> ஸாமவேதிகளுக்கும் மற்றவர்களுக்கும் சில வேறுபாடுகள்
    உள்ளன. அவ்வேறுவாடுகள் ஆங்காங்கே குறிக்கப்பட்டுள்ளதை கவனமாகப்
    பின்பற்றவும். </div>
    <hr>

  <div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">

    <div class="hint">தலையைத் தொட்டு :</div>
    <div class="prayogam">‘ஆஸன மந்த்ரஸ்ய - ப்ருதிவ்யா மேருப்ருஷ்ட ருஷி:’</div>
    <div class="sans">आसनमन्त्रस्य पृथिव्या मेरुपृष्ट ऋषि:</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">

    <div class="hint">மூக்கைத் தொட்டு :-</div>
    <div class="prayogam">‘சுதலம் சந்த:’</div>
    <div class="sans">सुतलं छन्द:</div>

  </div>
  <p class="clear"></p><hr>



  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">
    <div class="hint">மார்பைத் தொட்டு :-</div>
    <div class="prayogam">‘ஸ்ரீகூர்மோ தேவதா’</div>
    <div class="sans">श्रीकूर्मो देवता
    </div>

  </div>
  <hr>

  <div>
    <img src="assets/img/Nyaasam4.jpg" class="img2">

    <div class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</div>
    <div class="prayogam"> ‘ஆஸநே விநியோக:’</div>
    <div class="sans">आसने विनियोग:।</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/kaikoopu.jpg" class="img2">

    <div class="hint">
      கை கூப்பிக்கொண்டு சொல்லவும்
    </div>
  </div>
  <p class="clear"></p><hr>

  <div class="prayogam">“
    கூர்மாஸநாய நம:, கமலாஸநாய நம:,
    விமலாஸநாய நம:, பத்மாஸநாய நம:, யோகாஸநாய நம:”
    <br> ப்ருதிவி த்வயா த்ருதா லோகா தேவி த்வம் விஷ்ணுநா த்ருதா
    த்வஞ்ச தாரயமாம் தேவி பவித்ரம் குருசாஸநம்
     </div><br>
  <div class="sans">कूर्मासनाय नम: कमलासनाय नम: विमलासनाय नम: पद्मासनाय नम: योगासनाय नम:। पृथ्वि त्वया धृता लोका देवि त्वं विष्णुना धृता। त्वं
    च धारय मां देवि पवित्रं कुरुचासनम्।।</div><hr>
  <div class="hint">
    சில தர்பங்களை அந்த இடத்தில் போட்டுக்கொண்டு அமர்ந்து
    பின்வரும், ந்யாஸங்களைப் பண்ணவும்.
  </div><hr>

  <div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">
    <div class="prayogam">ப்ரணவஸ்ய ருஷி ப்ரஹ்மா</div>
    <div class="sans">प्रणवस्य ऋषि: ब्रह्मा</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">
    <div class="prayogam">தேவீ காயத்ரீ சந்த:</div>
    <div class="sans">देवी गायत्री छन्द:</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">
    <div class="prayogam">பரமாத்மா ஸ்ரீமந் நாராயணோ தேவதா</div>
    <div class="sans">परमात्मा श्रीमन्नारायणो देवता</div>
  </div>

  <p class="clear"></p><hr>


  <div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">

    <div class="prayogam">பூராதி ஸப்த வ்யாஹ்ருதீநாம்
      அத்ரி, ப்ருகு, குத்ஸ, வசிஷ்ட, கௌதம, காச்யப,
      அங்கீரஸ ருஷய:
    </div>
    <p class="clear"></p>
    <div class="sans">भूरादि सप्त व्याहृतीनां अत्रि, भृगु, कुत्स, वसिष्ठ, गौतम, काश्यप, आङ्गिरस ऋषय: ।</div>
    <div class="hint"> ஸாமம்: அத்ரி, ப்ருகு, குத்ஸ ருஷய:</div>
  </div><hr>





  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">

    <div class="prayogam">காயத்ரி, உஷ்ணிக், அநுஷ்டுப், ப்ருஹதி, பங்க்தி, த்ருஷ்டுப், ஜகத்ய:
      சந்தா(கு)ம்ஸி
      </div>
      <p class="clear"></p>
    <div class="sans">गायत्रि, उष्णिग्, अनुष्टुप्, बृहति, पङ्क्ति, त्रिष्टुप्, जगत्य: छन्दाँसि ।</div>
    <div class="hint"> ஸாமம் :
      காயத்ரி, உஷ்ணிக், அநுஷ்டுப் சந்தாம்ஸி
      </div>
  </div><hr>



  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">

    <div class="prayogam">அக்னி, வாயு, அர்க்க, வாகீச, வருண, இந்த்ர,
      விச்வேதேவா தேவதா:
      </div>

    <div class="sans">अग्नि, वायु, अर्क, वागीश, वरुण, इन्द्र, विश्वेदेवा देवता: ।</div>
    <div class="hint">ஸாமம்: அக்னி, வாயு, சூர்யோ தேவதா:

    </div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">

    <div class="prayogam">
      ஸாவித்ரியா ருஷி: விச்வாமித்ர:
    </div>
    <div class="sans">सावित्र्या ऋषि: विश्वामित्र: ।</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">

    <div class="prayogam">
      தேவீ காயத்ரி சந்த:
    </div>
    <div class="sans">देवी गायत्री छन्द:</div>
    <div class="hint">ஸாமம்: நிச்ருத், காயத்ரி சந்த:
      </div>
  </div>
  <p class="clear"></p><hr>


  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">

    <div class="prayogam">
      ஸவிதா தேவதா
      </div>
    <div class="sans">सविता देवता ।</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">

    <div class="prayogam">
      காயத்ரீ சிரஸ: ப்ரஹ்மா ருஷி:
      </div>
    <div class="sans">गायत्री शिरस: ब्रह्मा ऋषि:।</div>
    <div class="hint">
      ஸாமம் - இதை தவிர்க்கவும்
    </div>
  </div>
  <p class="clear"></p><hr>


  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">

    <div class="prayogam">
      அநுஷ்டுப் சந்த:
    </div>
    <div class="sans">अनुष्टुप् छन्द:।</div>
    <div class="hint">ஸாமம் - இதை தவிர்க்கவும்</div>
  </div>
  <p class="clear"></p><hr>


  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">

    <div class="prayogam">பரமாத்மா ஸ்ரீமந்நாராயணோ தேவதா
      </div>
    <div class="sans">परमात्मा देवता </div>
    <div class="hint">ஸாமம் - இதை தவிர்க்கவும்</div>
  </div>
  <p class="clear"></p><hr>


  <div>
    <img src="assets/img/Nyaasam4.jpg" class="img2">

    <div class="prayogam">
      ஸர்வேஷாம் ஜபே விநியோ:
    </div>
    <div class="sans">सर्वेषाम् जपेविनियोग:।</div>
  </div>

  <p class="clear"></p><hr>

  <div class="hint">மூன்று ப்ராணாயாமம் பண்ணவும்</div>
  <hr>
  <div>
      <img src="assets/img/praanaayaamam.gif">
    </div>


  <div class="prayogam">ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ: ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம்,
     தத்ஸவிதுர்வரேண்யம் பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத் ஓமாப: ஜ்யோதீரஸ:
    அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.</div>
  <div class="sans"></div>
  <hr>

  <div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">

    <div class="prayogam">ஆயாதிதி அநுவாகஸ்ய வாமதேவ ருஷி:</div>
    <div class="sans">आयात्विति अनुवाकस्य वामदेव ऋषि:।</div>
  </div>

  <p class="clear"></p><hr>



  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">

    <div class="prayogam">அநுஷ்டுப் ஜகத்யௌ சந்தா(கு)ம்ஸி
      </div>
    <div class="sans">अनुष्टुप् जगत्यौ छान्दाँसि</div>
  </div>
  <p class="clear"></p><hr>




  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">

    <div class="prayogam">காயத்ரீ தேவதா</div>
    <div class="sans">गायत्री देवता। </div>
  </div>

  <p class="clear"></p><hr>



  <div>
    <img src="assets/img/Nyaasam4.jpg" class="img2">

    <div class="prayogam">காயத்ரீ ஆவாஹநே விநியோக:</div>
    <div class="sans">गायत्री आवाहने विनियोग:।</div>
  </div>

  <p class="clear"></p><hr>
  <div>
    <img src="assets/img/kaikoopu.jpg" class="img2">


    <div class="hint">கையைக் கூப்பிக்கொண்டு சொல்லவும் </div>
  </div>
  <p class="clear"></p><hr>
  <div class="prayogam">
    “"ஆயாது வரதா தேவி அக்ஷரம் ப்ரஹ்ம ஸம்மிதம் காயத்ரீம் சந்தஸாம் மாதா
      இதம் ப்ரஹ்ம்ம ஜுஷஸ்வந: ஓஜோஸி ஸஹோஸி பலமஸி ப்ராஜோஸி தேவாநாம்
      தாமநாமாஸி விச்வமஸி விச்வாயு: ஸர்மஸி ஸர்வாயு: அபிபூரோம்
      காயத்ரீம் ஆவாஹயாமி (ஸாவித்ரீம் ஆவாஹயாமி ஸரஸ்வதீம் ஆவாஹயாமி)"
      (என்று காயத்ரீயை ஆவாஹனம் பண்ணிக்கொண்டு)
      ”
      <br> ப்ராதர் த்யாயாமி காயத்ரீம் ரவி மண்டல மத்யகாம்
      <br>ருக்வேதமுச்சாரயந்தீம் ரக்தவர்ணாம் குமாரிகாம்

      <br> அக்ஷமாலாகராம் ப்ரஹ்ம தைவத்யாம் ஹம்ஸவாஹநாம்

  </div>

  <div class="sans">आयातु वरदाा देवी अक्षरं ब्रह्मसंमितम्।
    <br> गायत्रीं छन्दसां माता इदं ब्रह्म जुषस्व न:।।
    <br> ओजोऽसि सहोसि बलमसि भ्राजोऽसि देवानां धामनामासि विश्वमसि विश्वायु: सर्वमसि सर्वायु: अभिभूरों गायत्रीम् आवाहयामि। (सावित्रीम्
    आवाहयामि, सरस्वतीम् आवाहयामि)
    <br> प्रातर्ध्यायामि गायत्रीं रविमण्डल मध्यगाम्।
    <br> ऋग्वेदमुच्चारयन्तीं रक्तवर्णां कुमारिकाम्।
    <br> अक्षमालाकरां ब्रह्मदैवत्यां हंसवाहानाम्।।</div>
    <hr>

  <div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">

    <div class="prayogam">ஸாவித்ரியா ருஷி: விச்வாமித்ர: </div>
    <div class="sans">सावित्र्या ऋषि: विश्वामित्र:</div>
  </div>

<p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">

    <div class="prayogam">தேவீ காயத்ரீ சந்த:</div>
    <div class="sans">देवी गायत्री छन्द:</div>
  </div>
  <p class="clear"></p><hr>


  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">

    <div class="prayogam">ஸவிதா தேவதா </div>
    <div class="sans">सविता देवता</div>
  </div>
  <p class="clear"></p><hr>
  <div>
    <img src="assets/img/kaikoopu.jpg" class="img2">
    <div class="hint">கை கூப்பிக்கொண்டு சொல்லவும்</div>
  </div>
  <p class="clear"></p><hr>
  <div class="prayogam">
    "சங்கச்சக்ர தரம் தேவம் கிரீடாதி விபூஷிதம் ஸூர்ய மண்டல மத்யஸ்த்தம் த்யாயேத்
      ஸ்வர்ணருசிம் ஹரிம் யோதேவ:
      ஸவிதா அஸ்மாகம் த்யோ தர்மாதி கோசரா: ப்ரேரயேத் தஸ்ய யத்பர்க்க: தத்வரேண்யம்
      உபாஸ்மஹே."    என்று த்யானித்து
  </div>
  <div class="sans">शंकचक्रधरं देवं किरीटादि विभूषितम्।
    <br> सूर्यमण्डल मध्यस्थं ध्यायेत् स्वर्ण रुचिं हरिम्।।
    <br> योदेव: सविता अस्माकं धियो धर्मादि गोचरा:।
    <br> प्रेरयेत् तस्य यद्भर्ग: तद्वरेण्यम् उपास्महे।।</div>
  <div class="hint">
      1008 அல்லது 108 தரம் ஸங்கல்பித்த ப்ரகாரம் ஜபம் பண்ணவும் </div><hr>
 <div class="mydiv">
      <div class="hint">
    காயத்ரியை 5 பாதங்களாக மனதிற்குள்
   ஜபிக்கவேண்டும்.</div>
   <hr style="color:red;">
   <div class="prayogam">
        1. ஓம் 2. பூர்புவஸ்ஸுவ: <br>
        3. தத்ஸவிதுர்வரேண்யம் <Br>
          4. பர்க்கோதேவஸ்ய தீமஹி <br>
          5. தியோயோந: ப்ரசோதயாத் </div>
          <div class="hint">
          (என 5 இடங்களில் நிறுத்தி) காயத்ரீ ஜபம் பண்ணவும்
  </div>
  <div class="sans">१) ओम् २) भूर्भुवस्सुव:<br>
     ३) तत्सवितुर्वरेणियम् ४) भर्गो देवस्य धीमहि <br>
     ५) धियोयोन:प्रचोदयात्।</div>
  </div><hr>

  <div class="hint"> காயத்ரி ஜபம் முடிந்ததும் ப்ராணாயாமமம் பண்ணவும் </div>
<hr>
  <div>
      <img src="assets/img/praanaayaamam.gif">
    </div>


  <div class="prayogam">ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ: ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம்,
     தத்ஸவிதுர்வரேண்யம் பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத் ஓமாப: ஜ்யோதீரஸ:
    அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.</div>
  <div class="sans"></div>
  <hr>
  <div class="head2">காயத்ரி உத்வாஸன ஸங்கல்பம்:</div><hr>
  <div>
    <img src="assets/img/Sankalpam.jpg" class="img2">
    <div class="hint"> வடகலை : </div>
    <div class="prayogam"> ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம்</div>
    <div class="hint"> தென்கலை :</div>
    <div class="prayogam"> ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீபகவத் கைங்கர்ய ரூபம்

    </div>

    <div class="hint"> ஸ்மார்த்தா :</div>
    <div class="prayogam">
      மமோபாத்த ஸமஸ்த துரிதக்ஷயத்வாரா ஸ்ரீபரமேஸ்வர ப்ரீத்யர்த்தம்
    </div>

    <div class="hint">அனைவரும் சொல்லவும்:</div>

    <div class="prayogam"> காயத்ரி உத்வாஸனம் கரிஷ்யே!</div>
    <div class="sans">गायत्रि उद्वासनम् करिष्ये।</div>
  </div>
<hr>

  <div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">

    <div class="prayogam">உத்தம இதி அநுவாகஸ்ய வாமதேவ ருஷி:</div>
    <div class="sans">उत्तम इति अनुवाकस्य वामदेव ऋषि:</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">

    <div class="prayogam">அநுஷ்டுப் சந்த:</div>
    <div class="sans">अनुष्टुप् छन्द:</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">

    <div class="prayogam">காயத்ரி தேவதா </div>
    <div class="sans">गायत्री देवता </div>
  </div>

  <p class="clear"></p><hr>
  <div>
    <img src="assets/img/Nyaasam4.jpg" class="img2">

    <div class="prayogam">காயத்ரி உத்வாஸநே விநியோக:</div>
    <div class="sans">गायत्री उद्वासने विनियोग:।</div>
  </div>
  <hr>
  <div>
    <img src="assets/img/kaikoopu.jpg" class="img2">
    <div class="hint">கை கூப்பிக்கொண்டு சொல்லவும்</div>
  </div>
  <p class="clear"></p><hr>

  <div class="prayogam">
    "உத்தமே சிகரே தேவி பூம்யாம் பர்வதமூர்தநி ப்ராம்மணேப்ய: ஹ்யநுக்ஞானம் கச்சதேவி
      யதாசுகம்"

  </div>
  <div class="sans">उत्तमे शिखरे देवी भूम्यां पर्वतमूर्धनि। ब्रह्मणेभ्य: ह्यनुज्ञानं गच्छ देवि यथासुखम्।।</div>


            <img src="assets/img/shastanga-namaskaram.jpg" class="img1">

          <div class="hint">
            எழுந்திருந்து ஸேவித்து </div>
            <p class="clear"></p><hr>

          <img src="assets/img/abhivathi.jpg" class="img1">

          <div class="hint">
            அபிவாதனம் பண்ணவேண்டியது.
      <br>பவித்ரம் பிரித்துப்போட்டு ஆசமனம் பண்ணறது. </div>

      <p class="clear"></p><hr>




  <div>
    <img src="assets/img/kaikoopu.jpg" class="img2">
    <div class="hint">கையைக் கூப்பிக்கொண்டு சொல்லவும்</div>
  </div>
  <p class="clear"></p><hr>
  <div class="hint">வடகலையார் மட்டும் : </div>
      <div class="prayogam">கை கூப்பிக்கொண்டு
      பகவாநேவ ஸ்வசேஷ பூதமிதம் காயாத்ரீ ஜபாக்யம் கர்ம ஸ்வஸ்மை
      ஸ்வப்ரீதயே பகவாந் ஸ்வயமேவ காரிதவான்
      என்று “ஸாத்வீக த்யாகம்” பண்ணிக் கொள்ளவும். </div>
      <hr>
      <div class="svk">
        அனைவரும் சொல்லலாம்.
      </div>
  <div class="prayogam">
    “காயேன வாசா மனஸா இந்த்ரியைர்வா புத்யா ஆத்மனாவா ப்ரஹ்ருதே: ச்வபாவாது கரோமி
      யத்யது ஸகலம் பரஸ்மை ஸ்ரீமன்நாராயணாயேதி ஸமர்பயாமி"
         .” ஸர்வம் ஸ்ரீக்ருஷ்ணார்ப்பணமஸ்து.
  </div>
  <div class="sans">
    कायेन वाचा मनसेन्द्रियैर्वा ।
    <br> बुद्ध्यात्मना वा प्रकृतिस्वभावात् ।
    <br> करोमि यद्यत्सकलं परस्मै ।
    <br> नारायणयेति समर्पयामि ॥
  </div>
  <hr>
  <div class="svk">பெருமாள் ஸேவித்து, பெரியவாளையும் ஸேவிக்கறது.</div>
    <div class="item"> மனம் நிறைந்த வாழ்த்துக்கள், குடும்பத்தாருடன், நோயற்ற வாழ்வு, குறைவற்ற செல்வம்,
    நீண்ட ஆயுளுடன், நிம்மதியாக வாழ எம்பெருமான் அருள்புரிய, ஆசீர்வாதங்களுடன்
    அல்லது வாழ்த்துக்களுடன் - வாத்யார்!
    <br>
    தாஸன்,<br>
    Dr.NVS </div>
<hr>
    </mat-tab>
    <mat-tab label="English">
     
      <mat-accordion>
        <mat-expansion-panel>
        <mat-expansion-panel-header>01-Things Required
        </mat-expansion-panel-header>
        <div class="div3">
         
          (1) Thiruman petti / Viboodhi
          <br> (2) Plate
          <br> (3) Tumbler with water
          <br> (4) Gaayathri Japam Manthram
          <br> (5) Pavithram etc.
          <br> (6) Manai palagai
          <br> (6) Beeds or nuts for counting
        </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>02-Instructions
          </mat-expansion-panel-header>
          <div class="div3">
            Gayathri Japam is a common ritual for all brahmins. Says the Manusmriti: "Tribhya eva tu Vedebyhah padam padamaduduham".
            It means that each pada of Gayatri is taken from one of the (three) Vedas. We have forsaken all else that is Vedic.
            What will be our fate if we give up the Gayatri mantra also? Gayatri-japa is essential to all rites performed according
            to the sastras At least on Sundays, all those who wear the sacred thread must do Gayatri japa a thousand times. They
            must not eat unclean food, goto unclean places and must atone for lapses in ritual observances and in maintaining
            ritual purity. Henceforth they must take every care to see that their body is kept chaste and fit for it to absorb
            mantric power. Gayatri contains in itself the spirit and energy of all Vedic mantras. Indeed it imparts power to
            other mantras. Without Gayatri-japa, the chanting of all other mantras would be futile. We find hypnotism useful
            in many ways and we talk of "hypnotic power". Gayatri is the hypnotic means of liberating ourselves from worldly
            existence as well as of controlling desire and realising the goal of birth. We must keep blowing on the spark that
            is the Gayatri and must take up the Gayatri-japa as vrata. The spark will not be extinguished if we do not take to
            unsastric ways of life and if we do not make our body unchaste. Gayatri must be worshiped as a mother. The Lord appers
            in many forms to bestow his grace and compassion on his devotees Mother loves us more than anybody else. We know
            no fear before her and talk to her freely. Of all the forms in which Bhagavan manifests himself that form in which
            he is revealed as mother is most liked by us. The Vedas proclaim Gayatri to be such a mother. Let us all pray to
            God that he will have mercy upon us so that the fire of mantras is never extinguished in us and that it will keep
            burning brighter and brighter. 

          </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>03-Preparations
            </mat-expansion-panel-header>
            <div class="div3">
              Wherever you be in the world, use the early morning time (Brahma Muhurtham) to wakeup on all days. Especially on this gaayathri
              japam day wake up early in the morning and take a simple bath. Do sandhya vandhanam. If you have the pavithram which
              is made up of two dharbhams, keep them ready to use. A pair of 'Yajgnopaveetam' also called Poonal is required for
              each gruhasta. And a Single poonal is required for each brahmachari. A place to be selected for Gayathri Japam, where
              there is no disturbance of TV or other entertainment players. And select a place where chidren will not come and
              disturb you while doing japam. 'Manai Kolam' to be drawn in the floor for each and a 'Manai Palagai' to be palced
              on it. The kolam also to be drawan on the palagai. Try to keep some betal nuts or some button like objects to count
              japam. If everything ready Do snanam Wear Panchakatcham Veshti Wear Thiruman or Thilakam Do Sandhya Vandhanam Don't
              forget to update your this Upakarma App before using for this year. We are often updating this application to make
              it easy and with latest feature and technology. So, it is a must to update it.

            </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
              <mat-expansion-panel-header>04-Manthrams
              </mat-expansion-panel-header>
              <div class="div3">
                Complete Mantrams given below Openly: Do not forget to visit our website often. To get all anushtana mantrams, Vaideeka mantrams,
                Poorvam Aparam complete guide, Shastra Sampradaya writeups everything exclusively for Sri Vaishnavites: http://www.ahobilam.com
                To get all anushtana mantrams, Vaideeka mantrams, Poorvam Aparam complete guide, Shastra Sampradaya writeups, all
                types od social, religious, ritual postings of more than 18000 genuine brahmin members in Tamil and English, Sanskrit,
                question Answers from experts, everything for all brahmin community including vaishnavites: http://www.brahminsnet.com/forums/forum.php
                Remember it serves FREE for you. Send your questions, get replied immediately.
                <br>Spread it over.
                <br>Regards,
                <br>Dr.NVS
              </div>
              </mat-expansion-panel>
      </mat-accordion>
            
    <hr class="new">
      <h1>Gayathri Japam <br> Yajur and All</h1>
      <div>
        <img src="assets/img/Praanaayaamam1.jpg" class="img2">
    
        <div class="hint">Sit facing East, insert two short dharbhams as seat under your legs</div>
      </div>
      <p class="clear"></p>
      <div>
        <img src="assets/img/Praanaayaamam2.jpg" class="img2">
    
        <div class="hint">Wear a pavithram made with two dharbhams in
           the Rt ring finger and fold two extra dharbhams along with it.</div>
      </div>
      <p class="clear"></p>
    
    
      <div>
        <img src="assets/img/Praanaayaamam3.jpg" class="img2">
    
        <div class="hint"style="height: 60px;">Press the rt nostrils with rt thumb</div>
      </div>
    
    <hr class="orange">
    
      
      <div>
        <img src="assets/img/Praanaayaamam4.jpg" class="img2">
        <div class="hint"> Fold both index and middle fingers towards inside,
          shut the mouth, inhale outside air through left nostril to fill your
          lung then shut the left nostrils also using ring and little finger.
          recite the below manthra thrice to complete one
          praaNaayaama
        </div>
      </div>
      <p class="clear"></p>
    
      <div class="prayogam">Om bhoohu Om bhuvaha O(gu)m suvaha Om mahaha Om janaha
         Om thapaha Om sathyam tatsavidhurvareaNyam bhargodhevasya dheemahi
        dhiyoyonah prachodhayaadh Omaapaha jyotheerasaha amrutham brahma bhoor bhuva suvar Om</div>
    
      <h2>Aachamanam</h2>
      <div class="hint">Achamanam and Praanayaamams are frequent actions done several times in any vaideeka karma. So,kindly use the below instructions
        and bring it in practice doing without any guide.</div>
      <h3 class="head2">Achamanam: </h3>
      <div class="sans">
        ओं अच्युताय नम:। ओं अनन्ताय नम:। ओं गोविन्दााय नम:।
        <br> ओं केशवाय नम:। नारायणाय नम:। माधवाय नम:। गोविन्दाय नम:। विष्णवे नम:। मधुसूदनाय नम:। त्रिविक्रमाय नम:। वामनाय नम:। श्रीधराय
        नम:। हृषीकेशाय नम:। पद्मनाभाय नम:। दामोदराय नम:।
      </div>
      <hr>
      <div class="head2">Praanaayamam:</div>
      <div class="sans">
        ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
        ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
      </div>
      <hr>
      <div>
        <img src="assets/img/new-achamanam.gif">
      </div>
      <div class="svk2">Achamanam - Audio|
          <audio controls>
          <source src="http://www.brahminsnet.com/upakarma/audio/achamanam.ogg" type="audio/ogg">
            <source src="http://www.brahminsnet.com/upakarma/audio/mp4/achamanam.mp4" type="audio/mp4">
        Your browser does not support the audio element.
        </audio>
        </div>
      <div class="hint">This Achamanam is to be done twice in the starting and end of any karma.</div>
    
      <h2>Praanaayaamam</h2>
      <div>
        <img src="assets/img/praanaayaamam.gif">
      </div>
    
    
      <div class="head2">START VADA KALAI ONLY</div>
    
      <div>
        <img src="assets/img/kaikoopu.jpg" class="img2">
        <div class="hint">Keep hands as doing namaskaaram (Kai koopikkondu) and start saying mantras...</div>
      </div>
    
    
      <div class="prayogam">Om asmath gurubhyo namaha. Sreemaan venkata naathaaryaha
        Kavithrkika kesari Vedaanthaacharya varyome; Sannidhattham sadhahrudhi.
        Gurubhyaha - thath gurubhyascha namovakam atheemahe Vruneemahecha thathraadhyau
        dhampathi jagadhampathi Swasesha bhuuthena
        maya sveeyai:(hi) sarva parichathai:(hi) Vidhathum preetam aatmaanam deva:(ha) prakramadhe swayam.</div>
      <hr>
        <div class="sans">
        ओं अस्मत्गुरुभ्या नम:। श्रीमान् वेङ्कटनाथार्य: कवितार्किककेसरी। वेवान्ताचार्यवर्यो मे सिन्नधत्तां सदाहृदि|| गुरुभ्य: तद्गुरुभ्यश्च
        नमोवाकं अधीमहे। वृणीमहे च तत्राद्यौ दम्पती जगतां पती ।। स्वशेष भूतेन मया स्वीयै: सर्वपरिच्छदै: । विधातुं प्रीतमात्मानं
        देव: प्रक्रमते स्वयम् ।।
    
      </div>
      <hr>
      <div class="head2">JOIN THEN KALAI & SMAARTHAA ALL</div>
    <hr>
      <div class="prayogam">Suklambharadharam vishnum sasivarnam chathur bhujam
        Prasanna vadhanam dhyayedh sarva vigna upasaanthaye. Yasyadhvradha
        vakrathyaha paarishathyaaha parassadham Vignam nignandhi sadhadham vishvaksenam tham aashraye.</div>
      <hr>
        <div class="sans">
        शुक्लाम्बरधरं विष्णुं शशिवर्णं चतुर्भुजम् । प्रसन्नवदनं ध्यायेत् सर्वविघ्नोपशान्तये ।। यस्यद्विरदवक्त्राद्या: पारिषद्या:
        पर:शतम् । विघ्नं निघ्नन्ति सततं विष्वसेनं तमाश्रये ।।
    
      </div>
    <hr>
      <div>
        <img src="assets/img/Sankalpam.jpg" class="img2">
        <div class="hint">At all Sankalpams keep the left hand as open in right thigh,
          place the right hand on it as closing </div>
      </div>
      <p class="clear"></p>
    
      <div class="prayogam"> Hari:(hi) Om Thath(u). Sri Govindha Govindhagovindha Asya
        sri bhagavadha:(ha) Maha purushasya Sri Vishno:(ho) ajgnaya pravarthamanasya
        adhya brahmana:(ha) dvidhiya parardhe sri swedhavaraha kalpe vaivasvadha
        manvanthare kaliyuge prathame padhe
      </div>
    
      <div class="svk">For people in India</div>
      <div class="prayogam"> Jambhu dweepe Bharadha varshe bharadhakhande</div>
    
      <div class="svk">For people outside India: </div>
        <div class="hint">You can replace the word 'Vishnu' in
         all places for which you dont know the names of dweepam,
        varsham and kandam Example: Vishnu dweepe, Vishnu Varshe, Vishu Khande.</div>
    
      <div class="svk">Manthram continues for all</div>
      <div class="prayogam">Sakaapthe meroho dhakshine paarswe asmin varthamaanaanaam
        vyavaharikaanaam Prabhavaadheenaam shasti samvathsaraanaam madhye
        .....
      </div>
      
     
      <div class="sans">
        हरि: ओं तत् (सत्) श्रीगोविन्द गोविन्द गोविन्द। अस्य श्रीभगवत: महापुरुषस्य श्रीविष्णो: आज्ञया प्रवर्तमानस्य अद्यब्रह्मण: द्वितीयपराार्धे
        श्रीश्वेतवराहकल्पे वैवस्त्वत मन्वन्तरे कळियुगे प्रथमेपादे जम्बूद्वीपे भारतवर्षे भरतखण्डे शकाब्दे मेरो: दक्षिणेपार्श्वे
        अस्मिन् वर्तमानानां व्यवहारिकाणां प्रभवादीनां षष्टिसंवत्सराणां मध्ये
      </div>
    <hr>
      <div class="head2">
        <b>Sankalpam for 12-08-2022:</b>
      </div>
      <hr>
      <div class="prayogam">

        Saarvari Naama Samvatsare<hr>
        dhakshinayane<hr>
        varsha ruthau<hr>
        simha mase<hr>
        krishna pakshe<hr>
        prathamaayaam subha thithau<hr>
        indhu vaasara yukthayam<hr>
        sathabhishak nakshatra yukthaayam<hr>
        athikanta (10.45 am) / sugarma yoga yukthaayam<hr>
        gaulava karana yukthaayam<hr>
        yevanguna visehana visishtaayam prathamaayaam subha thithau
   
        </div>
        <div class="svk2">12-08-2022-Sankalpam - Audio </div>
        <audio controls>
        <source src="http://www.brahminsnet.com/upakarma/audio/12-08-2022.ogg" type="audio/ogg">
          <source src="http://www.brahminsnet.com/upakarma/audio/mp4/12-08-2022.mp4" type="audio/mp4">
      Your browser does not support the audio element.
      </audio>
      <hr>
      <div class="sans">
        .... पिल्व नाम संवत्सरे दक्षिणयने - वर्ष ऋतौ   सिंह मासे कृष्ण पक्षे प्रथमायां शुभ तिथौ वासर:
  इन्दु वासर युक्तायां 
   सतभिषक् नक्षत्र युक्तायां  अतिकण्ठ(10.45am) / सुगर्म  योग युक्तायां गौलव  करण युक्तायां एवङ्गुण विशेषण विशिष्टायां अस्यां प्रथमायां शुभ
   तिथौ श्रीभगवदाज्ञया श्रीमन्नारायण प्रीत्यर्थं
      </div>
      <hr>
      <div class="head2">Gayathri Japa Sankalpam :</div>
    
      <div class="svk">
        <b>Vadakalai :</b>
      </div>
      <div class="prayogam"> Sri bhagavadhagnaya Sriman Narayana preethyartham</div>
    
      <div class="svk">
        <b>Thenkalai :</b>
      </div>
      <div class="prayogam"> Sri bhagavadhagnaya bhagavath kainkarya roopam (Use this convention in all the places)</div>
    
      <div class="svk">
        <b>Smaarthaa :</b>
      </div>
      <div class="prayogam"> Mamo partha samastha durithakshaya dwara , Sri Parameshwara preethyartham</div>
    
    
      <div class="svk">Both kalai and Smaarthaa:</div>
      <hr>
      <div class="prayogam">mithyaadheetha prayaschithaartham
        samvathsara praayaschithaartham Ashtothra sadha sankyaya -
        for 108 times Ashtothra Sahasra
        sankyaya - for 1008 times gaayathri maha manthra japam karishye!</div>
      <div class="sans"> मिथ्याधीत प्रायश्रित्तार्थं संवत्सर प्रायश्रित्तार्थं अष्टोत्तर(सहस्र)
        संख्यया गायत्री महामन्त्रजपं करिष्ये।
      </div>
      <div class="hint"> Note:- (This is called sankalpam, after this
        leave the short dharbhams on your left side i.e in north)
      </div>
      <div class="prayogam">Vadakalai only say: bhagavaneva swasesha bhootamitam
        gAyatri japAkyam karma swasmai swapreetaye bhagavan swayameva karayati.
        (sAtvika thyAgam).</div>
    <hr>
      <div class="svk">Both kalai and Smaarthaa:</div>
      <div class="hint"> stood up and sprinkle some water at the place where you
         going to sit for gAyatri japam and say</div>
         <hr>
      <div class="prayogam">
        “om bhurbhuvasuvaha”</div>
      <div class="sans">ओं भूर्भुवस्सुव:</div>
    
      <div class="hint">Pl. Note some changes are there between Sama Veda and Yajur
        Veda the changes for sama veda are given at required places
        as "Sama:" as prefix. If nothing mentioned, that part is same as other do.
      </div>
      <hr style="width:100%">
      <div>
        <img src="assets/img/Nyaasam1.jpg" class="img2">
    
        <div class="hint">Touch your fore head and tell :</div>
        <div class="prayogam">‘Asana mantrasya prutivyA meruprushta rushi:’</div>
        <div class="sans">आसनमन्त्रस्य पृथिव्या मेरुपृष्ट ऋषि:</div>
      </div>
      <p class="clear"></p>
    
    
      <hr style="width:100%">
    
      <div>
        <img src="assets/img/Nyaasam2.jpg" class="img2">
    
        <div class="hint">Touch your nose tip and tell :-</div>
        <div class="prayogam">‘sutalam chandaha’</div>
        <div class="sans">सुतलं छन्द:</div>
    
      </div>
      <p class="clear"></p>
    
    
    
      <div>
        <img src="assets/img/Nyaasam3.jpg" class="img2">
        <div class="hint">Touch your chest and tell :-</div>
        <div class="prayogam">‘sri koormo devadhaa’</div>
        <div class="sans">श्रीकूर्मो देवता
        </div>
    
      </div>
      <p class="clear"></p>
    
      <div>
        <img src="assets/img/Nyaasam4.jpg" class="img2">
    
        <div class="hint">Roll in both the palm towards your chest and roll inwards and tell :</div>
        <div class="prayogam"> ‘Asane viniyoga:’</div>
        <div class="sans">आसने विनियोग:।</div>
      </div>
    
      <p class="clear"></p>
    
      <div>
        <img src="assets/img/kaikoopu.jpg" class="img2">
    
        <div class="hint">Keep hands as doing namaskaaram (Kai koopikkondu) and tell</div>
      </div>
      <p class="clear"></p>
    
      <div class="prayogam">“koormasanAya namaha, kamalasanaya namaha1, vimalAsanAya namaha,
        padmAsanAya namaha, yogaasanaaya namaha”
        <br> prutividwya dhrutaa loka devi tvam vishnunA dhrutA tvamcha dhArayamAm devi pavitram kurchasanam” </div>
      <div class="sans">कूर्मासनाय नम: कमलासनाय नम: विमलासनाय नम: पद्मासनाय नम: योगासनाय नम:।
        पृथ्वि त्वया धृता लोका देवि त्वं विष्णुना धृता। त्वं
        च धारय मां देवि पवित्रं कुरुचासनम्।।</div>
      <div class="hint">Now sit on that place and start nyAsam as below:</div>
    
      <div>
        <img src="assets/img/Nyaasam1.jpg" class="img2">
        <div class="prayogam">Pranavasya rushi brahma;</div>
        <div class="sans">प्रणवस्य ऋषि: ब्रह्मा</div>
      </div>
      <p class="clear"></p>
    
    
      <div>
        <img src="assets/img/Nyaasam2.jpg" class="img2">
        <div class="prayogam">Devi Gayathri Chandaha</div>
        <div class="sans">देवी गायत्री छन्द:</div>
      </div>
      <p class="clear"></p>
    
    
      <div>
        <img src="assets/img/Nyaasam3.jpg" class="img2">
        <div class="prayogam">Paramaathmaa sriman naaraayaNo devadha</div>
        <div class="sans">परमात्मा श्रीमन्नारायणो देवता</div>
      </div>
      <p class="clear"></p>
    
    
    
      <div>
        <img src="assets/img/Nyaasam1.jpg" class="img2">
    
        <div class="prayogam">bhooraadhi saptha vyaahrudeenaam adhri, brugu, kuthsa, vashista,
          gowdhama, kaashyapa, angeerasa rushayaha</div>
        <div class="sans">भूरादि सप्त व्याहृतीनां अत्रि, भृगु, कुत्स, वसिष्ठ, गौतम, काश्यप, आङ्गिरस ऋषय: ।</div>
        <div class="hint"> Sama: adhri, brugu, kuthsa rushayaha</div>
      </div>
      <p class="clear"></p>
    
    
    
    
      <div>
        <img src="assets/img/Nyaasam2.jpg" class="img2">
    
        <div class="prayogam">gayathri, ushnig, anushtup, bruhati, pangthi, thrushtup, jagathyaha chanda(gu)msi</div>
        <div class="sans">गायत्रि, उष्णिग्, अनुष्टुप्, बृहति, पङ्क्ति, त्रिष्टुप्, जगत्य: छन्दाँसि ।
        </div>
        <div class="hint"> Sama : gayathri, ushnig, anushtup chandamsi</div>
      </div>
      <p class="clear"></p>
    
    
      <div>
        <img src="assets/img/Nyaasam3.jpg" class="img2">
    
        <div class="prayogam">agni, vaayu, arkka, vaagheesa, varuNa, indra viswedeva devataaha</div>
        <div class="sans">अग्नि, वायु, अर्क, वागीश, वरुण, इन्द्र, विश्वेदेवा देवता: ।</div>
        <div class="hint">Sama: agni, vaayu, sooryo devataaha</div>
      </div>
      <p class="clear"></p>
    
    
      <div>
        <img src="assets/img/Nyaasam1.jpg" class="img2">
    
        <div class="prayogam">savithriya rushihi viswaamitraha</div>
        <div class="sans">सावित्र्या ऋषि: विश्वामित्र: ।</div>
      </div>
      <p class="clear"></p>
    
    
      <div>
        <img src="assets/img/Nyaasam2.jpg" class="img2">
    
        <div class="prayogam">Devi gayathri chandaha</div>
        </div>
        <div class="sans">देवी गायत्री छन्द:</div>
        <div class="hint">Sama: Nichrudh Gayathri chandaha</div>
    
        <p class="clear"></p>
    
    
        <div>
          <img src="assets/img/Nyaasam3.jpg" class="img2">
    
          <div class="prayogam">savithaa devadhaa</div>
          <div class="sans">सविता देवता ।</div>
        </div>
        <p class="clear"></p>
    
    
        <div>
          <img src="assets/img/Nyaasam1.jpg" class="img2">
    
          <div class="prayogam">gaayathri shirasaha brahma rushihi</div>
          <div class="sans">गायत्री शिरस: ब्रह्मा ऋषि:।</div>
          <div class="hint">Sama: Avoid this</div>
        </div>
        <p class="clear"></p>
    
    
        <div>
          <img src="assets/img/Nyaasam2.jpg" class="img2">
    
          <div class="prayogam">anushtup chandaha</div>
          <div class="sans">अनुष्टुप् छन्द:।</div>
          <div class="hint">Sama: Avoid this</div>
        </div>
        <p class="clear"></p>
    
    
        <div>
          <img src="assets/img/Nyaasam3.jpg" class="img2">
    
          <div class="prayogam">paramaatmaa sriman naaraayano devadhaa</div>
          <div class="sans">परमात्मा देवता </div>
          <div class="hint">Sama: Avoid this</div>
        </div>
        <p class="clear"></p>
    
    
        <div>
          <img src="assets/img/Nyaasam4.jpg" class="img2">
    
          <div class="prayogam">sarveshaam jape viniyogaha</div>
          <div class="sans">सर्वेषाम् जपेविनियोग:।</div>
        </div>
        <p class="clear"></p>
    
    <hr>
        <div class="hint">Do Praanaayamams three times.</div>
        <hr>
        <div>
            <img src="assets/img/praanaayaamam.gif">
    
        </div>
    
        <p class="clear"></p>
    
        <div class="prayogam">Om bhoohu Om bhuvaha O(gu)m suvaha Om mahaha Om janaha
          Om thapaha Om sathyam tatsavidhurvareaNyam bhargodhevasya dheemahi
          dhiyoyonah prachodhayaadh Omaapaha jyotheerasaha amrutham brahma bhoor bhuva suvar Om</div>
        <div class="sans"></div>
    
    
        <div>
          <img src="assets/img/Nyaasam1.jpg" class="img2">
    
          <div class="prayogam">Aayaadhithi anuvaakasya vaamadeva rushi:</div>
          <div class="sans">आयात्विति अनुवाकस्य वामदेव ऋषि:।</div>
        </div>
    
    
    
        <hr style="width:100%">
    
        <div>
          <img src="assets/img/Nyaasam2.jpg" class="img2">
    
          <div class="prayogam">Anushtup jagathyau Chandhagumsi</div>
          <div class="sans">अनुष्टुप् जगत्यौ छान्दाँसि</div>
        </div>
        <p class="clear"></p>
    
    
        <hr style="width:100%">
    
        <div>
          <img src="assets/img/Nyaasam3.jpg" class="img2">
    
          <div class="prayogam">Gayathri devadha</div>
          <div class="sans">गायत्री देवता। </div>
        </div>
        <p class="clear"></p>
    
    
        <hr style="width:100%">
    
        <div>
          <img src="assets/img/Nyaasam4.jpg" class="img2">
    
          <div class="prayogam">Gaayathri aavaahane viniyoga:</div>
          <div class="sans">गायत्री आवाहने विनियोग:।</div>
        </div>
        <p class="clear"></p>
        <hr>
    
        <div>
          <img src="assets/img/kaikoopu.jpg" class="img2">
    <hr>
    
          <div class="hint">Keep hands as doing namaskaaram (Kai koopikkondu) and tell</div>
        </div>
        <p class="clear"></p>
        <div class="prayogam">
          “Aayaadhu varadha devi aksharam brahma sammidham, gaayathreem chandhasam maadha
           idham brahma jushasvana: ojosi, sahosi, bhalamasi,
          braajosi, devaanaam dhaama naamasi, viswamsi, visvayu: sarvamasi, sarvaayu:
           abhibhoorom gaayathreem aavaahayaami, saavithreem
          aavaahayami, sarasvatheem aavaahayaami”
          <br> prrtardhyaayaami gaayatreem ravimaNdala madhyagaam
          <br>rigvedamucchaarayanteem rakthavarNaam kumaarikaam.
          <br> akshamaalaakaraam brahmadaivatyaam hamsavaahanaam.
    
        </div>
        <hr>
        <div class="sans">आयातु वरदाा देवी अक्षरं ब्रह्मसंमितम्।
          <br> गायत्रीं छन्दसां माता इदं ब्रह्म जुषस्व न:।।
          <br> ओजोऽसि सहोसि बलमसि भ्राजोऽसि देवानां धामनामासि विश्वमसि विश्वायु: सर्वमसि सर्वायु: अभिभूरों गायत्रीम् आवाहयामि। (सावित्रीम्
          आवाहयामि, सरस्वतीम् आवाहयामि)
          <br> प्रातर्ध्यायामि गायत्रीं रविमण्डल मध्यगाम्।
          <br> ऋग्वेदमुच्चारयन्तीं रक्तवर्णां कुमारिकाम्।
          <br> अक्षमालाकरां ब्रह्मदैवत्यां हंसवाहानाम्।।</div>
       <hr>
    
        <div>
          <img src="assets/img/Nyaasam1.jpg" class="img2">
    
          <div class="prayogam">Saavithriya rushi: viswamithra:</div>
          <div class="sans">सावित्र्या ऋषि: विश्वामित्र:</div>
        </div>
        <p class="clear"></p>
    
    
        <div>
          <img src="assets/img/Nyaasam2.jpg" class="img2">
    
          <div class="prayogam">Devi gaayathri chandha:</div>
          <div class="sans">देवी गायत्री छन्द:</div>
        </div>
        <p class="clear"></p>
    
    
        <div>
          <img src="assets/img/Nyaasam3.jpg" class="img2">
    
          <div class="prayogam">Savitha devadha</div>
          <div class="sans">सविता देवता</div>
        </div>
        <p class="clear"></p>
        <hr>
        <div>
          <img src="assets/img/kaikoopu.jpg" class="img2">
          <div class="hint">Keep hands as doing namaskaaram (Kai koopikkondu) and tell</div>
        </div>
        <p class="clear"></p>
        <hr>
        <div class="prayogam">
          Chankachakra dharam devam kireetaathi vibhushidham Suryamandala madhyastham dhyaayeth
          swarna ruchim harim; Yodeva: savithasmaakam
          dhyodharmaadhi gochara: prerayeth thasya yathparkaha: thathvareannyam upaasmahe.
        </div>
        <hr>
        <div class="sans">शंकचक्रधरं देवं किरीटादि विभूषितम्।
          <br> सूर्यमण्डल मध्यस्थं ध्यायेत् स्वर्ण रुचिं हरिम्।।
          <br> योदेव: सविता अस्माकं धियो धर्मादि गोचरा:।
          <br> प्रेरयेत् तस्य यद्भर्ग: तद्वरेण्यम् उपास्महे।।
        </div>
        <hr>
        <div class="hint">
          Do gaayathri japam 108 times or 1008 times as per your option selected previously during the sankalpam.</div>
        <hr>
          <div class="prayogam">
          "Om!! Bhoorbuva suva:!! Thathsa vithur varaenyam!! bargo dhevasya dheemahi!! dhiyoyona: prachothayaath!!"
        </div>
        <hr>
        <div class="sans">१) ओम् २) भूर्भुवस्सुव: ३) तत्सवितुर्वरेणियम् ४) भर्गो देवस्य धीमहि ५) धियोयोन:प्रचोदयात्।</div>
        <hr>
        <div class="hint"> After the completion of the japam - do praanaayamam.</div>
    <hr>
        <div class="head2">Gaayathri Udhavaasana sankalpam:</div>
        <hr>
        <div>
          <img src="assets/img/Sankalpam.jpg" class="img2">
          <div class="svk"> Vadakalai : </div>
          <div class="prayogam"> Sri bhagavadhagnaya Sriman Narayana preethyartham
          </div>
          <div class="svk"> Thenkalai :</div>
          <div class="prayogam"> Sri bhagavadhagnaya bhagavath kainkarya roopam (Use this convention in all the places)</div>
          <div class="svk"> Smaarthaa :</div>
          <div class="prayogam"> Mamo partha samastha durithakshaya dwara , Sri Parameshwara preethyartham</div>
    
          <div class="svk">Both kalai and Smaarthaa:</div>
    
          <div class="prayogam"> gaayathri udhvaasanam karishye!</div>
          <div class="sans">गायत्रि उद्वासनम् करिष्ये।</div>
        </div>
    <hr>
    
        <div>
          <img src="assets/img/Nyaasam1.jpg" class="img2">
    
          <div class="prayogam">Uththama idhi anuvaakasya vaamadeva rushi:</div>
          <div class="sans">उत्तम इति अनुवाकस्य वामदेव ऋषि:
          </div>
        </div>
        <p class="clear"></p>
        <div>
          <img src="assets/img/Nyaasam2.jpg" class="img2">
    
          <div class="prayogam">Anushtup chandha:</div>
          <div class="sans">अनुष्टुप् छन्द:</div>
        </div>
        <p class="clear"></p>
        <div>
          <img src="assets/img/Nyaasam3.jpg" class="img2">
    
          <div class="prayogam">Gaayathri devadha</div>
          <div class="sans">गायत्री देवता </div>
        </div>
        <p class="clear"></p>
    
        <div>
          <img src="assets/img/Nyaasam4.jpg" class="img2">
    
          <div class="prayogam">Gaayathri udhvaasane viniyoga:
          </div>
          <div class="sans">गायत्री उद्वासने विनियोग:।
          </div>
        </div>
    
        <p class="clear"></p>
        <hr>
        <div>
          <img src="assets/img/kaikoopu.jpg" class="img2">
          <div class="hint">Keep hands as doing namaskaaram (Kai koopikkondu) and tell
          </div>
        </div>
        <p class="clear"></p>
    <hr>
        <div class="prayogam">
          “Uththame shikare devi bhoomyaam parvatha moorthani, brahmanebhya: hyanujgnanam gachcha devi yathashukham.”
        </div>
        <div class="sans">उत्तमे शिखरे देवी भूम्यां पर्वतमूर्धनि। ब्रह्मणेभ्य: ह्यनुज्ञानं गच्छ देवि यथासुखम्।।</div>
        <hr>
    
    
                  <img src="assets/img/shastanga-namaskaram.jpg" class="img1">
    
                <div class="hint">
                  Pranamya (do shaashtaanga namaskaaram) </div>
                  <p class="clear"></p>
                  <hr>
                <img src="assets/img/abhivathi.jpg" class="img1">
    
                <div class="hint">
                  Abhivadhya (do abhivaadhi).
            <br> Pavithram visrasya (remove and untie the pavithram)
            <br> Aachamya (do aachamanam) </div>
    
            <p class="clear"></p>
            <hr>
          <div>
            <img src="assets/img/kaikoopu.jpg" class="img2">
            <div class="hint">Keep hands as doing namaskaaram (Kai koopikkondu) and tell</div>
          </div>
          <p class="clear"></p>
          <hr>
          <div class="prayogam">
            “Kaayena vaacha manese indhriyairva, bhudhya, athmanaava, prahruthe: subhavaadhu,
            karomi yathyathu, sakhalam parasmai sriman
            naarayanyethi samarpayami.” Sarvam Sri Krishnaarpanamasthu.
          </div>
          <hr>
          <div class="sans">
            कायेन वाचा मनसेन्द्रियैर्वा ।
            <br> बुद्ध्यात्मना वा प्रकृतिस्वभावात् ।
            <br> करोमि यद्यत्सकलं परस्मै ।
            <br> नारायणयेति समर्पयामि ॥
            </div>
            <hr>
            <div class="item">Do namaskaaram to perumal at pooja room.
              <br> Do namaskaram to all elders.
             <br> Take food. Be blessed by all devatha.
             <br>Be happy throughout the year!
             <br>Dasan - Vadhyar
             <br>Dr.NVS
              </div>
              <hr>
              
    </mat-tab>
  </mat-tab-group>`;

const GayathrijapamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="காயத்ரி ஜபம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default GayathrijapamPage;
